import React, { Component } from "react";
import Spinner from "../../../Common/Spinner";
import Input from "../../Controls/Input";
import Window from "../../Controls/Window";

class PaymentConfigDrawer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        registrationId: "",
        gateway: "PHONEPE",
        environment: "",
        enable: true,
        storeId: "",
        storeName: "",
        credentials: {
          merchantId: "",
          phonePeStoreId: "",
        },
        terminals: [],
      },
    };
  }

  // componentDidMount runs once when drawer opens (since it's conditionally rendered)
  componentDidMount() {
    this.initializeFormData();
  }

 componentDidUpdate(prevProps) {
  // Check if storeData has changed
  const prevStoreId = prevProps.storeData && prevProps.storeData.hasOwnProperty('storeId') 
    ? prevProps.storeData.storeId 
    : null;
  const currentStoreId = this.props.storeData && this.props.storeData.hasOwnProperty('storeId') 
    ? this.props.storeData.storeId 
    : null;
  
  // Check if editData has changed
  const prevEditData = prevProps.editData || null;
  const currentEditData = this.props.editData || null;
  
  // Check if loadingCashRegister has changed from true to false (fetch completed)
  const prevLoading = prevProps.loadingCashRegister || false;
  const currentLoading = this.props.loadingCashRegister || false;
  
  // Re-initialize if storeData changed, editData changed, or loading just completed
  if (prevStoreId !== currentStoreId || 
      prevEditData !== currentEditData ||
      (prevLoading === true && currentLoading === false)) {
    this.initializeFormData();
  }
}

  initializeFormData = () => {
    const { editData, storeData, registrationId } = this.props;
    console.log("editData",editData);
    console.log("storeData",storeData);
    if (editData) {
      // For edit mode
      this.setState({ formData: editData });
    } else if (storeData) {
      // For new mode
      this.setState({
        formData: {
          registrationId: registrationId,
          gateway: "PHONEPE",
          environment: "",
          enable: true,
          credentials: {
            merchantId: "",
            phonePeStoreId: "",
          },
          storeId: storeData.storeId,
          storeName: storeData.storeName,
          terminals: (storeData.cashRegisters || []).map((r) => ({
            cashRegisterId: r.key,
            cashRegisterName: r.CashRegisterName,
            terminalId: "",
          })),
        },
      });
    }
  };

  componentDidMount() {
  this.initializeFormData();
  }

  handleUpdateTerminals = (value, index) => {
    const { formData } = this.state;
    const updated = [...formData.terminals];
    updated[index].terminalId = value;
    this.setState({ formData: { ...formData, terminals: updated } });
  };

  handleChange = (field, value) => {
    const { formData } = this.state;
    this.setState({
      formData: {
        ...formData,
        [field]: value,
      },
    });
  };

  handleCredentialChange = (field, value) => {
    const { formData } = this.state;
    this.setState({
      formData: {
        ...formData,
        credentials: {
          ...formData.credentials,
          [field]: value,
        },
      },
    });
  };

  handleSubmit = () => {
    const { formData } = this.state;
    const { onSave, onClose } = this.props;

    if (!formData.credentials.merchantId) {
      alert("Merchant ID required");
      return;
    }

    onSave(formData);
    onClose();
  };

  render() {
    const { onClose, editData, loadingCashRegister } = this.props;
    const { formData } = this.state;

    const isEdit = !!editData;
    const title = `${isEdit ? "Edit" : "New"} Setup`;

  

    const storeLabelStyles = {
      fontWeight: "600",
      color: "#1d4ed8",
      marginBottom: "16px",
      fontSize: "14px",
    };

    const sectionTitleStyles = {
      fontWeight: "600",
      color: "#374151",
      marginBottom: "8px",
      fontSize: "16px",
    };

    const terminalContainerStyles = {
      marginTop: "24px",
      borderTop: "1px solid #e5e7eb",
      paddingTop: "16px",
    };

    const terminalCardStyles = {
      border: "1px solid #e5e7eb",
      padding: "12px",
      marginBottom: "12px",
      borderRadius: "6px",
      backgroundColor: "#f9fafb",
    };

    const readOnlyInputStyles = {
      width: "100%",
      border: "1px solid #e5e7eb",
      backgroundColor: "#f3f4f6",
      borderRadius: "4px",
      padding: "8px 12px",
      fontSize: "14px",
      marginBottom: "8px",
    };

    const labelStyles = {
      fontSize: "12px",
      color: "#4b5563",
      marginBottom: "4px",
      display: "block",
    };

    return (
      <Window
        header={title}
        size="medium"
        slide={true}
        onClose={onClose}
        buttons={[
          {
            Text: "Cancel",
            Type: "secondary",
            Align: "left",
          },
          {
            Text: "Save Changes",
            Type: "primary",
            Align: "right",
          },
        ]}
        onButtonClick={(buttonText) => {
          if (buttonText === "Save Changes") {
            this.handleSubmit();
          } else {
            onClose();
          }
        }}
      >
        <div >
          <div style={storeLabelStyles}>
            Store: {formData.storeName}
          </div>

          <Input
            type="text"
            label="Merchant ID *"
            value={formData.credentials.merchantId}
            onChange={(value) => this.handleCredentialChange("merchantId", value)}
          />

          <Input
            type="text"
            label="PhonePe Store ID *"
            value={formData.credentials.phonePeStoreId}
            onChange={(value) => this.handleCredentialChange("phonePeStoreId", value)}
          />

          <div style={terminalContainerStyles}>
            <h3 style={sectionTitleStyles}>Terminal Mapping</h3>

            {loadingCashRegister ? (
              <div style={{ textAlign: "center", padding: "20px" }}>
                <Spinner />
              </div>
            ) : (
              <>
                {formData.terminals && formData.terminals.length > 0 ? (
                  formData.terminals.map((t, index) => (
                    <div style={terminalCardStyles} key={t.cashRegisterId || index}>
                      <label style={labelStyles}>Cash Register</label>
                      <input
                        type="text"
                        value={t.cashRegisterName}
                        readOnly
                        disabled
                        style={readOnlyInputStyles}
                      />

                      <Input
                        type="text"
                        label="Terminal ID"
                        value={t.terminalId}
                        onChange={(value) => this.handleUpdateTerminals(value, index)}
                      />
                    </div>
                  ))
                ) : (
                  <div style={{ textAlign: "center", padding: "20px", color: "#6b7280" }}>
                    No terminals available
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </Window>
    );
  }
}

export default PaymentConfigDrawer;